export const setPagination = (array, active) => {
  var objOutput = [];
  // first
  var firstItem = array[0];
  var secondItem = array[1];
  var thirdItem = array[2];
  var fourtItem = array[3];

  //   center
  var centerLeftItem = array.length >= 8 ? array[active - 2] : "";
  var centerItem = array.length >= 8 ? array[active - 1] : "";
  var centerRightItem = array.length >= 8 ? array[active] : "";

  //   last
  var lastFirstItem = array[array.length - 1];
  var lastSecondItem = array[array.length - 2];
  var lastThirdItem = array[array.length - 3];
  var lastFourtItem = array[array.length - 4];

  if (active < 3) {
    objOutput.push(firstItem);
    objOutput.push(secondItem);
    objOutput.push(thirdItem);

    //   empty
    objOutput.push("");

    //   last
    objOutput.push(lastThirdItem);
    objOutput.push(lastSecondItem);
    objOutput.push(lastFirstItem);
  } else if (active === 3) {
    objOutput.push(firstItem);
    objOutput.push(secondItem);
    objOutput.push(thirdItem);
    objOutput.push(fourtItem);

    //   empty
    objOutput.push("");

    //   last
    objOutput.push(lastThirdItem);
    objOutput.push(lastSecondItem);
    objOutput.push(lastFirstItem);
  } else if (active > 3 && active < array.length - 2) {
    objOutput.push(firstItem);
    objOutput.push("");
    objOutput.push(centerLeftItem);
    objOutput.push(centerItem);
    objOutput.push(centerRightItem);
    objOutput.push("");
    objOutput.push(lastFirstItem);
  } else if (active === array.length - 2) {
    objOutput.push(firstItem);
    objOutput.push(secondItem);
    objOutput.push(thirdItem);

    //   empty
    objOutput.push("");

    //   last
    objOutput.push(lastFourtItem);
    objOutput.push(lastThirdItem);
    objOutput.push(lastSecondItem);
    objOutput.push(lastFirstItem);
  } else if (active > array.length - 3 && active < array.length + 1) {
    objOutput.push(firstItem);
    objOutput.push(secondItem);
    objOutput.push(thirdItem);

    //   empty
    objOutput.push("");

    //   last
    objOutput.push(lastThirdItem);
    objOutput.push(lastSecondItem);
    objOutput.push(lastFirstItem);
  }

  return objOutput;
};
